package ui.resource.icons

import AppBuildConfig
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import compose.assets.Svg
import compose.assets.svg.Arrow_left
import compose.assets.svg.Refresh
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.icons_listing__load_more
import ssoft.frontend.generated.resources.icons_listing__no_match
import ssoft.frontend.generated.resources.icons_listing__search
import tk.mallumo.compose.navigation.ComposableNavNode
import tk.mallumo.utils.DataState
import tools.GlobalObjectShare
import tools.rememberString
import ui.widget.ErrUI
import ui.widget.LazyIcon
import ui.widget.LoadingUI
import ui.widget.SearchUI

@Composable
@ComposableNavNode
fun IconsListingUI() {
    with(IconsListingScope.rememberScope()) {
        when (vm.state) {
            is DataState.Error -> ErrUI()
            is DataState.Idle,
            is DataState.Loading -> LoadingUI()

            is DataState.Result -> Content()
        }

    }
}

@Composable
private fun IconsListingScope.Content() {
    Column(
        modifier = Modifier.fillMaxSize()
    ) {
        Row(Modifier.padding(horizontal = 16.dp).padding(top = 16.dp)) {
            IconButton(
                onClick = {
                    nav.up(1)
                },
                colors = IconButtonDefaults.iconButtonColors(
                    containerColor = MaterialTheme.colorScheme.primaryContainer,
                    contentColor = MaterialTheme.colorScheme.onPrimaryContainer
                ),
                modifier = Modifier.align(Alignment.CenterVertically)
                    .padding(horizontal = 4.dp)
            ) {
                Icon(
                    imageVector = Svg.Arrow_left,
                    contentDescription = null,
                    modifier = Modifier.padding(4.dp)
                )
            }

            SearchUI(
                filed = vm.searchFiled,
                modifier = Modifier.width(256.dp),
                label = Res.string.icons_listing__search
            ) {
                action(IconsListingVM.Action.Query)
            }

            IconButton(
                onClick = {
                    action(IconsListingVM.Action.Random)
                },
                colors = IconButtonDefaults.iconButtonColors(
                    containerColor = MaterialTheme.colorScheme.secondaryContainer,
                    contentColor = MaterialTheme.colorScheme.onSecondaryContainer
                ),
                modifier = Modifier.align(Alignment.CenterVertically)
                    .padding(horizontal = 4.dp)
            ) {
                Icon(
                    imageVector = Svg.Refresh,
                    contentDescription = null,
                    modifier = Modifier.padding(4.dp)
                )
            }
        }

        LazyVerticalGrid(
            columns = GridCells.FixedSize(96.dp),
            modifier = Modifier.fillMaxSize(),
            contentPadding = PaddingValues(16.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            vm.state.entry
                ?.state
                ?.takeIf { it.isNotEmpty() }
                ?.also { items ->
                    items(items) {
                        Item(it)
                    }
                    if (items.isNotEmpty() && items.size % 100 == 0) {
                        item(span = {
                            GridItemSpan(maxLineSpan)
                        }) {
                            LoadMore()
                        }
                    }
                } ?: run {
                item(span = {
                    GridItemSpan(maxLineSpan)
                }) {
                    Box(Modifier.fillMaxSize()) {
                        Text(
                            text = Res.string.icons_listing__no_match.rememberString(),
                            style = MaterialTheme.typography.titleMedium,
                            modifier = Modifier.align(Alignment.Center)
                        )
                    }
                }
            }

        }
    }
}

@Composable
private fun IconsListingScope.LoadMore() {
    Box(Modifier.fillMaxWidth()) {
        Button(
            onClick = {
                action(IconsListingVM.Action.LoadMore)
            },
            modifier = Modifier.align(Alignment.Center)
        ) {
            Text(
                text = Res.string.icons_listing__load_more.rememberString(),
                fontWeight = FontWeight.Bold
            )
        }
    }
}

@Composable
private fun IconsListingScope.Item(item: IconsListingScope.Wrapper.Item) {
    Column {
        Card(
            onClick = {
                GlobalObjectShare.onIconPick(item.data)
                nav.up()
            },
            modifier = Modifier.width(96.dp)
        ) {
            Column {
                LazyIcon(
                    id = item.data.id,
                    tint = Color.White,
                    modifier = Modifier.fillMaxWidth()
                        .size(96.dp)
                        .padding(8.dp)
                )

                Text(
                    text = item.data.name,
                    style = MaterialTheme.typography.labelMedium,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                    modifier = Modifier.fillMaxWidth()
                        .background(Color.Black)
                        .padding(4.dp)
                )

            }
        }
        if(AppBuildConfig.DEBUG){
            SelectionContainer {
                Text(
                    text = item.data.id.toString(),
                    style = MaterialTheme.typography.labelMedium,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                    modifier = Modifier.width(96.dp)
                        .background(Color.Black)
                        .padding(2.dp)
                )
            }
        }
    }
}
